import {segment} from './helpers'

/**
 * Used to track when the category page has filters applied.
 *
 * @param {string} [filterValue] The value of the filter
 * @param {string} [filterName] The name of the filter
 * @param {string} [productCategory] The product category where filter applied
 * @param {number} [productCount] The number of products matching the filter on the page
 * @param {boolean|undefined} [isDefaultDateChanged] If date filter, is the value the default date?
 */
export const categoryFiltered = (
  filterValue,
  filterName,
  productCategory,
  productCount,
  isDefaultDateChanged,
) => {
  segment('Filtered Category Page', {
    filterValue,
    filterName,
    productCategory,
    productCount,
    isDefaultDateChanged,
  })
}

/**
 * Used to track when a user views a Product Category Page
 *
 * @param {string} productCategory The name of the category page viewed
 */
export const viewedProductCategory = (productCategory) =>
  segment('Viewed Product Category', {productCategory})

/**
 * Used to track when a user clicks on a product from the category page.
 *
 * @param {Object} [trackingProperties] Properties for tracking event
 * @param {string} [trackingProperties.targetPath] Product target path
 * @param {string} [trackingProperties.targetName] Product name
 * @param {boolean} [trackingProperties.isRentSoldOut] Is product sold out for rental
 * @param {string} [trackingProperties.rentPrice] Product rent price
 * @param {boolean} [trackingProperties.isBuySoldOut] Is product sold out for buy
 * @param {string} [trackingProperties.buyPrice] Product buy price
 * @param {boolean} [trackingProperties.isDateFilterApplied] Is selected date filter applied
 */
export const clickedCategoryPageProduct = ({
  targetPath,
  targetName,
  isRentSoldOut,
  rentPrice,
  isBuySoldOut,
  buyPrice,
  isDateFilterApplied,
}) =>
  segment('Clicked Category Page Product', {
    targetPath,
    targetName,
    isRentSoldOut,
    rentPrice,
    isBuySoldOut,
    buyPrice,
    isDateFilterApplied,
  })

export const clickedBuyPathExperimentControl = () =>
  segment('Clicked Buy Path Experiment PCP link to control')
